import { Link } from 'react-router-dom';
import { ROUTES } from '@/utils/constants';
import { CreatorNav } from '@/components/shared/CreatorNav';
import { Footer } from '@/components/shared/Footer';

export function ProfileNotFound() {
  return (
    <div className="ap-page">
      <CreatorNav />
      <main className="ap-main ap-not-found">
        <svg
          className="ap-not-found__doodle"
          viewBox="0 0 160 160"
          aria-hidden="true"
        >
          <circle cx="20" cy="24" r="3" fill="var(--ap-text-muted)" />
          <circle cx="34" cy="24" r="3" fill="var(--ap-text-muted)" />
          <circle cx="20" cy="38" r="3" fill="var(--ap-text-muted)" />
          <g transform="rotate(-4 80 80)">
            <rect
              x="35"
              y="35"
              width="90"
              height="90"
              rx="10"
              fill="var(--ap-text)"
            />
            <text
              x="80"
              y="97"
              textAnchor="middle"
              fontFamily="var(--ap-font-display)"
              fontSize="52"
              fontWeight="800"
              fill="var(--ap-yellow)"
            >
              ?
            </text>
          </g>
          <circle cx="140" cy="130" r="3" fill="var(--ap-text-muted)" />
          <circle cx="126" cy="130" r="3" fill="var(--ap-text-muted)" />
          <circle cx="140" cy="144" r="3" fill="var(--ap-text-muted)" />
        </svg>
        <h1 className="ap-not-found__title">This page doesn&apos;t exist</h1>
        <p className="ap-not-found__text">
          That handle isn&apos;t taken on Nestra yet. Double check the link,
          or make it yours.
        </p>
        <Link to={ROUTES.SIGNUP} className="landing-btn landing-btn--coral">
          Create your Nestra
        </Link>
      </main>
      <Footer />
    </div>
  );
}
